var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 22 14",
    style: {
      enableBackground: "new 0 0 22 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9,0.8c-2.2,0-4.3,0.6-6.2,1.7c-1.7,1-3.1,2.3-4.2,4c-0.2,0.3-0.2,0.8,0,1.1c1.1,1.6,2.5,3,4.2,4 c1.9,1.1,4,1.7,6.2,1.7c2.2,0,4.3-0.6,6.2-1.7c1.7-1,3.1-2.3,4.2-4c0.2-0.3,0.2-0.8,0-1.1c-1.1-1.6-2.5-3-4.2-4 C15.2,1.4,13.1,0.8,10.9,0.8z M10.9,2.8c1.8,0,3.6,0.5,5.2,1.4l0.3,0.2c1.1,0.7,2,1.5,2.8,2.5L19.2,7l-0.1,0.1 c-0.8,1.1-1.9,2-3.1,2.7c-1.6,0.9-3.3,1.4-5.2,1.4c-1.8,0-3.6-0.5-5.2-1.4L5.4,9.6c-1.1-0.7-2-1.5-2.8-2.5L2.6,7l0.1-0.1 c0.8-1.1,1.9-2,3.1-2.7C7.3,3.3,9.1,2.8,10.9,2.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11,3.9C9.3,3.9,7.9,5.3,7.9,7 c0,1.7,1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1c0-0.6-0.5-1-1-1L13,6c0,0-0.1,0-0.1,0C12.4,6,12,5.6,12,5.1l0-0.1L12,5 C12.1,4.4,11.6,3.9,11,3.9z M10.2,6.2L10.2,6.2C10.5,7,11,7.5,11.7,7.8l0.1,0l0,0C11.6,8,11.3,8.1,11,8.1c-0.6,0-1.1-0.5-1.1-1.1 C9.9,6.7,10,6.4,10.2,6.2L10.2,6.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.21599429b45b103803cfda75f1785e90.svg";
export { ForwardRef as ReactComponent };